import { createMonitoringLogger } from '@grafana/runtime';

export const queryLogger = createMonitoringLogger('features.query');
